import Icon from 'veui/components/Icon'
import { IconEllipsis } from 'dls-icons-vue'

Icon.register('ellipsis', IconEllipsis)
